import { Link, Outlet } from "react-router-dom";
import { useMemo } from "react";
import { Plus } from "lucide-react";
import { PageHeader } from "@/components/ui/PageHeader";
import { Tabs, type TabItem } from "@/components/ui/Tabs";
import { useAuthStore } from "@/store/auth";

export function RoutesLayout() {
  const user = useAuthStore((s) => s.user);
  const canPlan = !!user;
  const tabs = useMemo<TabItem[]>(() => {
    const t: TabItem[] = [{ to: "/routes", label: "All", end: true }];
    if (canPlan) t.push({ to: "/routes/plan", label: "Plan New" });
    t.push({ to: "/routes/map", label: "Map" });
    return t;
  }, [canPlan]);

  return (
    <div>
      <PageHeader
        title="Routes"
        description="Plan, optimize, and dispatch field-sales routes."
        actions={
          canPlan ? (
            <Link
              to="/routes/plan"
              className="inline-flex items-center gap-1.5 rounded-md bg-brand-600 px-3 py-1.5 text-sm font-medium text-white shadow-sm hover:bg-brand-700"
            >
              <Plus className="h-4 w-4" />
              New Route
            </Link>
          ) : null
        }
      />
      <Tabs items={tabs} />
      <div className="px-4 py-4 sm:px-8 sm:py-6">
        <Outlet />
      </div>
    </div>
  );
}
